import React from 'react'

export default function PullOutInventoryFormStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        /* MODAL FORM style override */
        .modal-content-container.pull-out-inventory-form .modal-form-footer {
          color: black;
        }
        /* MODAL FORM */

        #current-item-stock-status-container {
          padding: 10px;
          display: flex;
          flex-direction: column;
          background-color: whitesmoke;
        }

        #table-item-units-container {
          background-color: whitesmoke;
          font-size: 1rem;
        }
        #table-item-units-container th {
          /*font-size: 0.9em;*/
          text-align: left;
          padding: 5px;
        }
        #table-item-units-container td {
          /*font-size: 0.9em;*/
          text-align: left;
          padding: 5px;
        }
        #table-item-units-container th:nth-child(1), td:nth-child(1) {
          width: 30%;
        }
        #table-item-units-container th:nth-child(2), td:nth-child(2) {
          width: 15%;
        }
        #table-item-units-container th:nth-child(3), td:nth-child(3) {
          width: 5%;
        }
        #table-item-units-container th:nth-child(4), td:nth-child(4) {
          width: 5%;
        }

        #table-pulled-out-summary {
          border: solid 1px lightgreen;
          font-size: 1rem;
          padding: 10px;
          width: 75%;
        }
        #table-pulled-out-summary th:nth-child(1), td:nth-child(1) {
          width: 75%;
        }

        .pull-out-quantity {
          padding: 5px;
          text-align: center;
        }

        #out-of-stock-message {
          font-size: 1.2rem;
          padding: 15px 0;
        }

        #pull-out-message {
          font-size: 1rem;
          padding: 15px 0;
        }

        #actions-buttons-group {
          margin-top: 20px;
          display: flex;
          justify-content: flex-end;
        }

        #notification {
          display: none;
          flex: 1;
          padding: 5px;
          font-size: 1rem;
          color: red;
        }
      `}
      </style>
    </React.Fragment>
  )
}
